module.exports = __webpack_public_path__ + "img/kankou_18.ae1c17ae.jpg";